<main class="d-flex align-items-center flex-column">
    <div class="align-self-center ms-1 me-1">
        <adapt-survey-container [survey]="archetypeSurvey"></adapt-survey-container>
    </div>
</main>
